import Vue from 'vue'
import {mapGetters} from 'vuex'
import DirectionInternalResult from './direction-internal-result/index'
import GoogleLinkOnly from 'js/pages/planner/google-link-only/index'
import StopsInternalResult from './stops-internal-result/index'

import template from './index.pug'

export default Vue.extend({
  name: 'planner-page',
  template: template(),
  components: {
    DirectionInternalResult,
    GoogleLinkOnly,
    StopsInternalResult
  },

  computed: {
    plannerBehaviour() {
      return this.currentAppConfig.planner_behaviour
    },

    showDirectionInternalResult() {
      return this.plannerBehaviour === 'direction_internal_result'
    },

    showGoogleLinkOnly() {
      return this.plannerBehaviour === 'google_link_only'
    },

    showStopsInternalResult() {
      return this.plannerBehaviour === 'stops_internal_result'
    }
  }
})
